export default __webpack_public_path__ + "static/media/guild-active.acca253c.svg";